/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Scale, Phone, Mail, MapPin, ExternalLink, ShieldCheck } from 'lucide-react';
import { Logo } from '../ui/Logo';
import Settings from '../../utils/Settings';

interface FooterProps {
  setView: (view: string) => void;
}

export const Footer: React.FC<FooterProps> = ({ setView }) => {
  return (
    <footer className="bg-[#0F051D] text-zinc-300 border-t border-zinc-800 pt-16 pb-8 font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          
          {/* Brand Col */}
          <div className="space-y-4">
            <div className="flex items-center text-white">
              <Logo variant="white" height={42} />
            </div>
            <p className="text-xs text-zinc-400 leading-relaxed font-normal">
              La bibliothèque numérique de référence pour les juristes, magistrats, avocats, huissiers et dirigeants d’entreprises au Cameroun.
            </p>
          </div>

          {/* Quick Access */}
          <div>
            <h3 className="text-white text-xs font-semibold uppercase tracking-wider mb-4 border-b border-zinc-800 pb-2">
              Navigation Rapide
            </h3>
            <ul className="space-y-2 text-xs text-zinc-450">
              <li>
                <button onClick={() => setView('home')} className="hover:text-white cursor-pointer transition-colors focus:outline-none">
                  Page d'accueil
                </button>
              </li>
              <li>
                <button onClick={() => setView('categories')} className="hover:text-white cursor-pointer transition-colors focus:outline-none">
                  Explorateur thématique
                </button>
              </li>
              <li>
                <button onClick={() => setView('search')} className="hover:text-white cursor-pointer transition-colors focus:outline-none">
                  Moteur de recherche avancée
                </button>
              </li>
              <li>
                <button onClick={() => setView('dashboard')} className="hover:text-white cursor-pointer transition-colors focus:outline-none">
                  Tableau de bord ("Mon Espace")
                </button>
              </li>
            </ul>
          </div>

          {/* Physical Address / Contacts */}
          <div>
            <h3 className="text-white text-xs font-semibold uppercase tracking-wider mb-4 border-b border-zinc-800 pb-2">
              Assistance & Contact
            </h3>
            <ul className="space-y-3 text-xs text-zinc-400">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-primary-400 shrink-0" />
                <span> {Settings.phone}</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-primary-400 shrink-0" />
                <span> {Settings.email} </span>
              </li>
            </ul>
          </div>

        </div>

        {/* Legal Mentions */}
        <div className="border-t border-zinc-805 pt-8 flex flex-col md:flex-row items-center justify-between text-[11px] text-zinc-550">
          <p>© 2026 DOCARN SERVICES SARL. Tous droits de reproduction réservés.</p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="#" className="hover:underline hover:text-white transition-colors">CGU</a>
            <a href="#" className="hover:underline hover:text-white transition-colors">Politique de Confidentialité</a>
            <a href="#" className="hover:underline hover:text-white transition-colors">Mentions Légales</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
